import { nightsBetween } from './format';

/**
 * Display-only day count for search summaries («4 jours»).
 * Mirrors the server rule (an extra day when the return is 2 h or more after the pickup time).
 * The price of record always comes from the server quote; never compute money from this.
 */
export const EXTRA_DAY_GRACE_MINUTES = 120;

const minutes = (hhmm: string): number => {
  const [h = '0', m = '0'] = hhmm.split(':');
  return Number(h) * 60 + Number(m);
};

export function billableDays(start: string, end: string, pickupTime: string, returnTime: string): number {
  const nights = Math.max(0, nightsBetween(start, end));
  const late = minutes(returnTime) - minutes(pickupTime) >= EXTRA_DAY_GRACE_MINUTES;
  return Math.max(1, nights + (late ? 1 : 0));
}

export function isLateReturn(pickupTime: string, returnTime: string): boolean {
  return minutes(returnTime) - minutes(pickupTime) >= EXTRA_DAY_GRACE_MINUTES;
}

/** 30-minute slots from 07:00 to 21:00. */
export const TIME_SLOTS: string[] = Array.from({ length: 29 }, (_, i) => {
  const t = 7 * 60 + i * 30;
  return `${String(Math.floor(t / 60)).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
});

/** Next or previous slot, clamped to the range. */
export function stepTime(current: string, direction: 1 | -1): string {
  const i = TIME_SLOTS.indexOf(current);
  const next = Math.min(TIME_SLOTS.length - 1, Math.max(0, (i < 0 ? 6 : i) + direction));
  return TIME_SLOTS[next] ?? current;
}

/** «10:00» + 2 h → «12:00» (for the grace note). */
export function addMinutes(hhmm: string, add: number): string {
  const t = minutes(hhmm) + add;
  return `${String(Math.floor(t / 60) % 24).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
}
